<template>
  <!-- banner topo-->
  <div v-if="bannerTopo != ''" class="slider-area">
    <div class="slider-height2 slider-bg2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="offset-xl-1 col-xl-5 col-lg-5 col-md-5">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END banner topo-->

  <!-- Blog -->
  <section class="blog_area section-padding">
    <div v-if="listaBlog.length > 0" class="container">
      <div class="row">
        <div class="col-lg-8 mb-5 mb-lg-0">
          <div v-for="noticia in primeiraNoticia" :key="noticia.itiId" class="blog_left_sidebar">


            <article class="blog_item">
              <!-- imagem ------------------------------>
              <div class="blog_item_img">
                <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)">
                  <img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" alt=""
                    :style="{ backgroundImage: 'url(' + $imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem + ')' }"
                    class="card-img-avance img-cant-red">
                </router-link>
                <!-- data ------------------------------>
                <div class="blog_item_date">
                  <h3 class="date_day">{{ formattedDateDia(noticia.itiData1) }}</h3>
                  <p class="date_month">{{ formattedDateMes(noticia.itiData1) }}</p>
                </div>
              </div>
              <!-- textos ------------------------------>
              <div class="blog_details">
                <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
                  class="d-inline-block">
                  <h2 class="blog-head" style="color: #2d2d2d;">{{ noticia.itiNome }}</h2>
                </router-link>
                <p>{{ resumoCurto(noticia.itiResumo1) }}</p>
              </div>
            </article>

          </div>
        </div>

        <!-- ultimas noticias -->
        <div class="col-lg-4">
          <div class="blog_right_sidebar">
            <aside class="single_sidebar_widget popular_post_widget">
              <h3 class="widget_title" style="color: #2d2d2d;">Últimas Notícias</h3>
              <div v-for="noticia in listaBlog" :key="noticia.itiId" class="media post_item d-flex align-items-start">
                <img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" alt="" class="post-item-avance">
                <div class="media-body">
                  <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
                    class="d-inline-block">
                    <h3 style="color: #2d2d2d;">{{ noticia.itiNome }}</h3>
                  </router-link>
                </div>
              </div>
            </aside>
          </div>
        </div>
        <!-- END ultimas noticias -->

      </div>
    </div>
  </section>
  <!-- END Blog -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'BlogView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    listaBlog: [],

  }),

  computed: {
    primeiraNoticia() {
      return this.listaBlog.length > 0 ? [this.listaBlog[0]] : [];
    }
  },

  methods: {
    /* resumo curto da primeira noticia */
    resumoCurto(conteudo) {
      const textoLimpo = this.removerTagsHTML(conteudo);
      const limite = 200; // você pode ajustar esse número
      return textoLimpo.length > limite ? textoLimpo.slice(0, limite) + '...' : textoLimpo;
    },

    /* paginador */
    changePage(page) {
      this.currentPage = page;
      window.scrollTo({ top: 0, behavior: 'smooth' }); // opcional
    },

    /* data */
    formattedDateDia(value) {
      return this.$moment(value).format('DD')
    },
    formattedDateMes(value) {
      const mes = this.$moment(value).format('MM')
      return mes.charAt(0).toUpperCase() + mes.slice(1)
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'FiançAqui Garantidora - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "FiançAqui Garantidora" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
  const element = document.createElement('div');
  element.innerHTML = html;
  return element.textContent || element.innerText || '';
},

    /*removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },*/

    filtraNoticia(categoria) {
      let _filtro = this.listaNoticias.filter(x => x.itiReferencia == categoria);
      this.firstNoticia = _filtro[0];
      this.otherNoticas = _filtro.slice(1, 6);
      this.finalNoticias = _filtro.slice(7);
    }
  },

  created() {

    //aqui banner topo
    axios.get('/Process/InsInstitucional/institucional/27/toponoticias/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('banner blog')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca notícias
    axios.get('/Process/InsInstitucional/institucional/50/noticias/0/itiData1')
      .then(response => {
        this.listaBlog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const timeA = a.itiData1
            ? new Date(a.itiData1).getTime()
            : 0;
          const timeB = b.itiData1
            ? new Date(b.itiData1).getTime()
            : 0;
          return timeA - timeB;
        }).reverse();
        //console.log('noticias')
        //console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>